import { ApiModel, ApiResource } from 'lib/interfaces/api';

export type CallResult = {
  rows: Record<string, string | number | boolean | null | undefined>[];
  keys: string[];
};

export enum ExternalIntegrationCallStatus {
  Ready = 'ready',
  Processing = 'processing',
  Completed = 'completed',
  Errored = 'errored',
  Cancelled = 'cancelled',
  TimedOut = 'timed-out',
}

export type ExternalIntegrationCallLoadingState = {
  status: ExternalIntegrationCallStatus | null;
};

export interface ExternalIntegrationCallAttributes {
  status: ExternalIntegrationCallStatus;
  'created-at': string | null;
  'updated-at': string | null;
  'redacted-at': string | null;
  'errored-at': string | null;
  'error-message': string | null;
  'completed-at': string | null;
  'cancelled-at': string | null;
  'timed-out-at': string | null;
  'call-result': CallResult | null;
  'external-integration-id': string;
}

export type ExternalIntegrationCall = ApiResource<
  ExternalIntegrationCallAttributes,
  {},
  ApiModel.ExternalIntegrationCall
>;

export type ExternalIntegrationCallPayload = {
  type: ApiModel.ExternalIntegrationCall;
  attributes: {
    'external-integration-id': string;
    query?: {
      sql: string;
      options: {
        limit?: number;
        offset?: number;
      };
    };
  };
};
